// extracted by mini-css-extract-plugin
export default {"loader__container":"wVmV97QBbYIkxcO6Qtv4"};